<div id="outer" class="well container" style="width: 50%">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="col-md-12">
        <div class="well-notify"></div>
    </div>
    <div class="well-title">
        <div class="col-md-12">User Agreements</div>
    </div>
    @if (!loading) {
        <div
            class="col-md-12 well-content"
            style="display: flex; flex-direction: column; align-items: center; height: 100%">
            <div class="panel" [innerHTML]="formTemplate"></div>
            <div class="form-group">
                <input type="checkbox" [(ngModel)]="agree" (ngModelChange)="this.disagree = false" /> {{ agreeMessage
                }}<br />
                <input type="checkbox" [(ngModel)]="disagree" (ngModelChange)="this.agree = false" />
                {{ disagreeMessage }}
            </div>
            @if (agree || disagree) {
                <button
                    class="btn btn-default"
                    [ngStyle]="{
                        'background-color': logoutOnDecline && !agree ? 'red' : null,
                        color: logoutOnDecline && !agree ? 'white' : 'black'
                    }"
                    (click)="save()">
                    {{ logoutOnDecline && !agree ? logoutMessage : okMessage }}
                </button>
            }
        </div>
    }
</div>
